import { render, staticRenderFns } from "./TipsBottomPopup.vue?vue&type=template&id=0bc388de&scoped=true"
import script from "./TipsBottomPopup.vue?vue&type=script&lang=js"
export * from "./TipsBottomPopup.vue?vue&type=script&lang=js"
import style0 from "./TipsBottomPopup.vue?vue&type=style&index=0&id=0bc388de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc388de",
  null
  
)

export default component.exports